module.exports = __webpack_public_path__ + "img/智能消杀灯.550aa071.png";